export default __webpack_public_path__ + "alberta-rehab-aids.5f14957f4a1f06b5cf04.svg";